import dayjs from "dayjs"
import "dayjs/locale/ru"
import timezone_ from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import { OPERATION_DATE_FORMAT } from "./operation"

dayjs.extend(utc)
dayjs.extend(timezone_)

export const extractTime = (date: string) => {
  const operationDate = new Date(date)
  const hours = operationDate.getHours()
  const minutes = operationDate.getMinutes()
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`
}

export const getTimezone = (date: string) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return `${dayjs(date).format(OPERATION_DATE_FORMAT)} ${timezone}`
}

export const formatMoscowDateTime = (date: string) =>
  dayjs(date).locale("ru").tz("Europe/Moscow").format("D MMMM YYYY HH:mm")
